import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { PRODUCTS } from '@/modules/marketing/components/product-visuals';

const SLIDE_INTERVAL_MS = 5000;

/** Auto-advancing showcase of AIPA's three flagship products — one at a time, 5s apart, pausing on hover. Reuses the exact gradient banners from the homepage's ProductsSection so the story is consistent wherever a visitor sees it. */
export function ProductSlider() {
    const [index, setIndex] = useState(0);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (paused) return undefined;

        const timer = setInterval(() => setIndex((i) => (i + 1) % PRODUCTS.length), SLIDE_INTERVAL_MS);
        return () => clearInterval(timer);
    }, [paused]);

    const product = PRODUCTS[index];

    return (
        <div
            className="overflow-hidden rounded-2xl border bg-card shadow-lg"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
        >
            <div className={cn('bg-gradient-to-br p-6 text-white transition-colors duration-500', product.gradient)}>
                <div className="flex size-10 items-center justify-center rounded-lg bg-white/15">
                    <product.icon className="size-5" />
                </div>
                <p className="mt-3 text-[11px] font-bold uppercase tracking-wider opacity-70">{product.eyebrow}</p>
                <h3 className="text-xl font-bold">{product.title}</h3>
            </div>

            <div className="flex flex-col items-center gap-4 p-6">
                {product.visual}
                <p className="text-center text-sm text-muted-foreground">{product.description}</p>
            </div>

            <div className="flex items-center justify-center gap-2 pb-5">
                {PRODUCTS.map((p, i) => (
                    <button
                        key={p.key}
                        type="button"
                        aria-label={`Show ${p.title}`}
                        onClick={() => setIndex(i)}
                        className={cn('h-1.5 rounded-full transition-all', i === index ? 'w-6 bg-primary' : 'w-1.5 bg-muted')}
                    />
                ))}
            </div>
        </div>
    );
}
